import { IAppProps, IAppProviderState } from '../interface/IAppProvider';
import { getDataFromObjectCache, sendDataToObjectCache } from '../async/AsyncCalls';
import { setSessionItem, getSessionItem } from '../services/StorageService';
import { TDispatch } from '../context/AppContext';

interface IObjectCacheResp {
  objectId: string;
}

export const saveToObjectCache = (props: IAppProps, state: IAppProviderState, appDispatch: TDispatch) => {
  appDispatch({ isLoading: true });
  sendDataToObjectCache(props, appDispatch, { data: updateObject(state) }).then((response: IObjectCacheResp) => {
    if (response) {
      setSessionItem('onsa-travel-session-key', response.objectId);
      appDispatch({ isLoading: false });
    } else {
      props.c9log.error(`Something went wrong in promise when trying to save the data to cache`, 'Actions');
      appDispatch({ hasError: { stepOne: true, stepTwo: false } });
    }
  });
};

export const reloadApplicationStateFromCache = async (props: IAppProps, appDispatch: TDispatch) => {
  const key = getSessionItem('onsa-travel-session-key');
  if (key) {
    getDataFromObjectCache(props, appDispatch, key).then((response) => {
      if (response) {
        const stateFromObjectCache = response.object.data;
        appDispatch({
          ...stateFromObjectCache,
          initialState: false,
          stateChange: false,
          refreshFromCache: true
        });
      } else {
        appDispatch({ hasError: { stepOne: true, stepTwo: false } });
      }
    });
  } else {
    appDispatch({ refreshFromCache: true });
  }
};

export const updateObject = (globalState: IAppProviderState) => {
  const stateCopy = { ...globalState };
  //Match with initial state for browser refresh
  stateCopy.refreshFromCache = false;
  return stateCopy;
};
